export default (to, from, next) => {

  if (import.meta.env.VITE_APP_ENV === 'local' || import.meta.env.VITE_APP_ENV === 'staging') {
    document.title = `[${import.meta.env.VITE_APP_ENV}] ${document.title}`;
  }

  return next();
};
